import { WidgetBackground, WidgetBorder } from "../colors";
import * as Colors from "../colors";
import { MuiComponent } from "./type";

export const MuiPopover: MuiComponent<"MuiPopover"> = {
  // styleOverrides: {
  //   root: {
  //     "& .MuiBackdrop-root": {
  //       backgroundColor: "rgba(0, 0, 0, 0.65)",
  //       backdropFilter: "blur(2px)",
  //     },
  //   },
  // },
};

export const MuiMenu: MuiComponent<"MuiMenu"> = {
  styleOverrides: {
    paper: {
      backgroundColor: WidgetBackground,
      borderRadius: "12px",
      border: `1px solid ${WidgetBorder}`,
      color: "#fff",
      minWidth: "200px",
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
      marginTop: "8px",
      padding: "0",

      "&::before": {
        display: "none",
      },
    },
    list: {
      padding: "8px 0",
    },

  },
};

export const MuiMenuItem: MuiComponent<"MuiMenuItem"> = {
  styleOverrides: {
    root: {
      color: "#fff",
      fontSize: "14px",
      fontWeight: 500,
      padding: "8px 16px",
      display: "flex",
      alignItems: "center",
      gap: "16px",
      "&:hover": {
        backgroundColor: Colors.Selected,
        color: "#fff!important",
        fontWeight: 600,
      },
    },
  },
};
